import { queryOptions } from '@tanstack/react-query';
import { EdgeData } from '@/services/twttr-graph-service';
import { traceError } from '@/utils/trace-error';

const fetchEdges = async (
  node: string,
  edgeDirection: string,
): Promise<number[]> => {
  const url =
    edgeDirection === 'in'
      ? `/static/edges_v1/in/${node}.json`
      : `/static/edges_v1/${node}.json`;

  const res = await fetch(url);

  if (res.ok) {
    return res.json();
  }

  if (res.status === 404 || res.status === 403) {
    return [] as number[];
  }

  throw new Error(
    `request to edges failed with: ${res.status} ${res.statusText}`,
  );
};

export const edgesQueryOptions = (
  node: string,
  edgeDirection?: string | null,
) => {
  const safeDir = edgeDirection === 'in' ? 'in' : 'out';

  return queryOptions({
    queryKey: ['edges', node, edgeDirection],
    queryFn: () =>
      fetchEdges(node, safeDir)
        .then(
          (data) =>
            data.map((edge) =>
              edgeDirection === 'in'
                ? [edge, Number(node)]
                : [Number(node), edge],
            ) as EdgeData[],
        )
        .catch((err) => {
          // TODO: show toast
          traceError(
            new Error(
              `Failed to load ${edgeDirection} edges for node ${node}`,
              {
                cause: err,
              },
            ),
          );
          return [];
        }),
    enabled: !!node,
    staleTime: Infinity,
    retry: false,
  });
};
